import React from 'react';
import './downloads.scss';

const Downloads = () => {
    return (
        <div className='downloads'>
            <h4>Descargas</h4>
            <p>Puedes descargarte las fichas de nuestro equipo para poder vivir emocionantes aventuras junto a ellos:</p>
            <a href='https://drive.google.com/drive/folders/1C69sZlJRvCqDOsMnatK5tUOPrNQJXaNL?usp=sharing' target='blank'>Descargar fichas de los personajes</a>
        </div>
    );
}

export default Downloads;
